<template>
  <div :class="['content', {'zh-style': language === 'zh'}]">
    <empty-reminder v-if="records.length === 0 && !loading"></empty-reminder>

    <div id="pc-records" v-if="records.length > 0">
      <div class="little-title">
        <p class="time">{{ $t('time') }}</p>
        <p class="description">{{ $t('description') }}</p>
        <p class="amount">{{ $t('amount') }}</p>
      </div>

      <template v-for="record in records">
        <div class="records-lists">
          <p class="time">{{ record.created_at | createFormatTime(record.created_at) }}</p>
          <p class="description">
            <span>
              {{ $t('yourFriends') }} {{ record.nickname }} {{ $t('bought') }} {{ record.package_device_count }} {{ $tc('devices', record.package_device_count)}}
              {{ $t(record.package_name) }}{{ $t('plan') }}
              <template v-if="record.status === 'cancelled'">{{ $t('refunded') }}</template>
            </span>
          </p>
          <p :class="['amount', {'cancelled': record.status === 'cancelled'}]">{{ record.award_days }} {{ $tc('days', record.award_days) }}</p>
        </div>
      </template>
    </div>

    <div id="pager-bar" v-if="records.length > 0">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager :totalPage="totalPage" :init-page="currentPage" mode="event" @go-page="getAwardRecords"></pager>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import {createFormatTime} from 'src/lib/filters'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import Pager from '../../pager/Index.vue'

  export default {
    name: 'reward-record-pc',
    components: {EmptyReminder, Pager, Spinner},
    props: ['initAwardRecordsData'],
    data: function () {
      return {
        totalPage: 0,
        currentPage: 1,
        records: [],
        loading: false
      }
    },
    locales,
    computed: {
      language() {
        return this.$store.state.currentLang
      }
    },
    watch: {
      initAwardRecordsData() {
        this.records = this.initAwardRecordsData.data
        this.totalPage = Math.ceil(this.initAwardRecordsData.meta['total'] / this.initAwardRecordsData.meta['per_page'])
        this.currentPage = this.initAwardRecordsData.meta['current_page']
      }
    },
    methods: {
      getAwardRecords(data) {
        this.loading = true
        this.$http.get('api/award-records', {params: {'page': data.page}}).then(response => {
          this.loading = false
          this.records = response.data.data
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
          this.currentPage = this.initAwardRecordsData.meta['current_page']
        }, response => {
          this.loading = false
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .content {
    min-height: 2.16rem;
  }

  #pc-records {
    min-height: 4.5rem;
  }

  .little-title {
    line-height: .2rem;
    padding: .17rem 0;
    font-size: 0;
    color: #333333;
    font-weight: 600;
    letter-spacing: 0;
    border-bottom: .01rem solid #E0D7E3;
    display: flex;
  }

  .records-lists {
    line-height: .2rem;
    padding: .17rem 0;
    font-size: 0;
    color: #666;
    letter-spacing: 0;
    border-bottom: .01rem solid #E0D7E3;
    display: flex;
  }

  .little-title p, .records-lists p {
    font-size: .14rem;
    display: inline-block;
  }

  .time {
    flex-basis: 20%;
    text-align: center;
  }

  .description {
    flex-basis: 70%;
    text-align: center;
    span {
      display: inline-block;
      width: 100%;
      margin: 0 auto;
      text-align: center;
      @media screen and (min-width: 1200px) {
        width: 5.2rem;
      }
    }
    a {
      color: #999;
      text-decoration: underline;
      &:hover, &:focus, &:active {
        color: $base-blue;
      }
    }
  }

  .amount {
    flex-basis: 10%;
    text-align: center;
    .cancelled {
      color: #D5D5D5;
    }
  }

  @mixin zh-style() {
    .description {
      span {
        @media screen and (min-width: 1235px) {
          width: 4.4rem;
        }
      }
    }
  }

  .zh-style {
    @include zh-style();
  }

  #pager-bar {
    padding-bottom: .4rem;
    text-align: center;
    .spinner-component-box {
      min-height: .8rem;
      padding: .1rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// RewardRecordsPc.vue?5b982ebc